import styled from "styled-components";
import { Modal } from "takeat-design-system-ui-kit";

export const BackBalconyButton = styled.div`
  color: var(--Takeat-Colors-Primary-Red, #C8131B);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  cursor: pointer;
  margin-left: auto;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  align-self: center;
`

export const BalconyResetFlowModal = styled(Modal)`
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;

  > section {
    width: 52px;
    height: 52px;
  }

  > div {
    width: 404px;
    display: flex;
    flex-direction: column;

    > header {
      display: flex;
      flex-direction: row;
      gap: 16px;

      > div {
        display: flex;
        flex-direction: column;

        > p {
          color: var(--Takeat-Colors-Neutrals-Black-01, #222);
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 133.333% */
          letter-spacing: var(--Headline-Small-Tracking, 0);
          margin: 0 0 8px 0;
          padding: 0;
        }
  
        > div {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          > span {
            color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);
            align-self: stretch;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: 0.1px;
          }
        }
      }
    }

    > main {
      margin: 8px 0 24px 0;
    }

    > footer {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }
  }
`

export const BalconyFlowLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;

  > svg {
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`